// vendor
import { defineComponent, ref, computed, onUnmounted } from "@vue/composition-api";
import { Socket } from "socket.io-client";
// project
import * as SessionAPI from "@/services/api/sessions";
import * as AssetAPI from "@/services/api/assets";
import * as StudyAPI from "@/services/api/studies";
import { Asset, Session, SessionState, Study } from "@/psychlab/types";
// relative
import SessionTimer from "../vue/session-timer.vue";
import SessionProgress from "../vue/session-progress.vue";

export const MonitorSession = defineComponent({

	components:{
		SessionProgress,
		SessionTimer
	},
	props:{
		sessionId:{
			type:String,
			required:true
		}
	},
	setup(props, context){
		const session = ref<Session>();
		const state = ref<SessionState>();
		const eventSocket = ref<Socket>();
		const study = ref<Study>();
		const blueprint = ref<Asset>();

		const studyId = computed(() => session.value ? session.value.group : undefined);
		const blueprintId = computed(() => session.value ? session.value.asset : undefined);
		
		const nodePath = computed(() => session.value ? session.value.path : undefined);
		const graph = computed(() => session.value ? session.value.graph : undefined);

		const breadcrumbs = computed(() => {
			if(!study.value || !session.value){ return []; }
			return [
				{
					text: "Monitor",
					to: {
						name: "Run.Group.Monitor",
						params:{
							groupId:studyId.value
						}
					}
				},
				{
					text: `Session, id: ${session.value._id}`,
					active: true
				}
			];
		});

		onUnmounted(() => {
			if(eventSocket.value){
				eventSocket.value.close();
			}
		});

		const onSessionDeleted = () => {
			// add logic to handle deletion
		}

		const stateModified = (newState:SessionState) => {
			state.value = newState;
		}

		const init = async() => {
			// session
			try{
				session.value = await SessionAPI.loadSession(props.sessionId, true);
				state.value = session.value.state;
			}
			catch(err){ console.error(err); }
			if(!session.value){ return; }
			
			// study
			try { study.value = await StudyAPI.getStudy(session.value.group); }
			catch(err){ console.error(err.message); }
			// blueprint
			try { await AssetAPI.getAsset(session.value.asset) }
			catch(err){ console.error(err); }
			// live updates
			eventSocket.value = SessionAPI.createSessionSocket(props.sessionId, `bearer ${context.root.$store.getters.token}`);
			eventSocket.value.on("error", () => console.log("error!"));
			eventSocket.value.on("disconnect", (msg:any) => console.log("io disconnect"));
			eventSocket.value.on("state", stateModified);
			eventSocket.value.on("deleted", onSessionDeleted);
			eventSocket.value.open();
		};

		init();

		return {
			breadcrumbs,
			session,
			state,
			studyId,
			blueprintId,
			nodePath,
			graph
		};
		
	}


});